<template>
    <div class="filter">
        <img v-if="!value" ref="showFilter" src="@/assets/images/filter.svg" class="filter__icon" @click="showPopper = !showPopper" />
        <img v-else ref="showFilter" src="@/assets/images/filter-filled.svg" class="filter__icon" @click="showPopper = !showPopper" />
        <div
            v-if="showPopper"
            id="filterPopper"
            ref="filterPopper"
            class="filter__popup"
        >
            <slot />
            <div class="filter__actions">
                <RsvButton color="blue" text="Применить" @click="apply" />
                <RsvButton color="white" text="Очистить" @click="clear" />
            </div>
        </div>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";
import RsvButton from "@/components/UI/RsvButton/RsvButton.vue";

export default {
    name: "ExpertPanelTableFilter",
    components: { RsvButton },
    props: {
        value: [String, Array],
    },
    data() {
        return {
            showPopper: false,
            popper: null,
        };
    },
    watch: {
        showPopper() {
            if (this.showPopper) {
                this.$nextTick(() => {
                    const elem = this.$refs.showFilter;
                    const filterPopper = this.$refs.filterPopper;
                    this.popper = createPopper(elem, filterPopper, {
                        placement: 'bottom',
                    });
                });
            } else {
                if (this.popper) {
                    this.popper.destroy();
                }
            }
        },
    },
    methods: {
        apply() {
            this.showPopper = false;
            this.$emit('apply');
        },
        clear() {
            this.showPopper = false;
            this.$emit('clear');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.filter {
  &__popup {
    box-shadow: 0 rem(1) rem(5) #0003, 0 rem(2) rem(2) #00000024, 0 rem(3) rem(1) rem(-2) #0000001f;
    background: #fff;
    border-radius: rem(10);
    padding: rem(10);
  }
  &__icon {
    cursor: pointer;
  }
  &__actions {
    margin-top: rem(10);
    display: flex;
    gap: rem(10);
  }
}
</style>